import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
  GetAllTemplates,
  CreateFromTemplate
};

function GetAllTemplates(contractId, versionId, editionId, onSuccess, onError){

    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/templates`,  headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function CreateFromTemplate(templateId, contractId, versionId, editionId, ruleConfigId, ruleGroupId, onSuccess, onError){

  const headers = getAuthHeader();

  const params = {};

  if(ruleConfigId != null) params.ruleConfigId = ruleConfigId;
  if(ruleGroupId != null) params.ruleGroupId = ruleGroupId;

  axios
      .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/templates/${templateId}`, 
        {}, // empty body
        { "params": params, "headers": headers.headers }
      )
      .then(response => {
          onSuccess(response.data); 
      })
      .catch(error => {
          onError(error);
      });
}


